<template>
  <div class="container">
    <loading-wrap :loading="loading">
      <div class="row justify-content-center pt-5">
        <div class="col-8">
          <h4>{{form._id ? 'Edit' : 'Create'}} Assessment</h4>
          <div class="alert alert-danger" v-if="error">{{error}}</div>
          <form @submit.prevent="submit">
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Student First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Student First Name"
                    required
                    v-model="form.firstName"
                  >
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Student Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Student Last Name"
                    required
                    v-model="form.lastName"
                  >
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Student Gender</label>
                  <v-select
                    v-model="form.gender"
                    :clearable="false"
                    :options="['male', 'female']"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{option.name}}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize">{{option.name}}</span>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Parent First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Parent First Name"
                    required
                    v-model="form.parentFirstName"
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>Parent Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Parent Last Name"
                    required
                    v-model="form.parentLastName"
                  >
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Tutor First Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tutor First Name"
                    required
                    v-model="form.tutorFirstName"
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>Tutor Last Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Tutor Last Name"
                    required
                    v-model="form.tutorLastName"
                  >
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-6">
                <div class="form-group">
                  <label>Phone Number</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="0000 000 000"
                    required
                    v-model="form.phone"
                  >
                </div>
              </div>
              <div class="col-6">
                <div class="form-group">
                  <label>Email Address</label>
                  <input
                    type="email"
                    class="form-control"
                    placeholder="Email Address"
                    required
                    v-model="form.email"
                  >
                </div>
              </div>
            </div>
            <hr>
            <div class="row">
              <div class="col-4">
                <div class="form-group">
                  <label>Date of Assessment</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="DD/MM/YY"
                    required
                    v-model="form.dateOfAssessment"
                  >
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>
                    Year Level
                    <help-tip title="Prep = 0"/>
                  </label>
                  <input
                    type="number"
                    class="form-control"
                    min="0"
                    step="1"
                    max="7"
                    placeholder="Year Level"
                    required
                    v-model="form.yearLevel"
                  >
                </div>
              </div>
              <div class="col-4">
                <div class="form-group">
                  <label>Subject</label>
                  <v-select
                    v-model="form.subject"
                    :clearable="false"
                    :options="['english', 'maths']"
                    label="name"
                  >
                    <template slot="selected-option" slot-scope="option">
                      <span style="text-transform: capitalize">{{option.name}}</span>
                    </template>
                    <template slot="option" slot-scope="option">
                      <div class="d-flex">
                        <span style="text-transform: capitalize">{{option.name}}</span>
                      </div>
                    </template>
                  </v-select>
                </div>
              </div>
            </div>
            <div class="row" v-if="!this.form._id">
              <div class="col-8">
                <label>Template</label>
                <v-select v-model="template" :clearable="false" :options="templates" label="name">
                  <template slot="selected-option" slot-scope="option">
                    <span style="text-transform: capitalize">{{option.name}}</span>
                  </template>
                  <template slot="option" slot-scope="option">
                    <div class="d-flex">
                      <span
                        style="text-transform: capitalize"
                      >{{option.name}}, Grade: {{option.yearLevel}}, Subject: {{option.subject}}</span>
                    </div>
                  </template>
                </v-select>
              </div>
            </div>
            <hr>
            <div class="text-right">
              <button type="submit" class="btn btn-success btn-lg" :disabled="formLoading">
                <svg-loader/>
                <span>Submit</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </loading-wrap>
  </div>
</template>

<script>
export default {
  data() {
    return {
      error: "",
      templates: [],
      categorys: [],
      loading: true,
      formLoading: false,
      template: null,
      form: {
        firstName: "",
        lastName: "",
        parentFirstName: "",
        parentLastName: "",
        tutorFirstName: "",
        tutorLastName: "",
        phone: "",
        email: "",
        dateOfAssessment: "",
        yearLevel: null,
        subject: "",
        questions: [],
        assessmentText: ""
      }
    };
  },
  watch: {
    template(newVal) {
      this.form = {
        ...this.form,
        questions: newVal.questions,
        assessmentText: newVal.assessmentText
      };
    }
  },
  created() {
    this.axios.get("/api/categorys").then(res => {
      this.categorys = res.data;
    });

    const { id } = this.$route.query;
    if (id) {
      this.axios.get("/api/assessments/" + id).then(res => {
        this.form = res.data;
        this.loading = false;
      });
    } else {
      this.axios.get("/api/templates").then(res => {
        this.templates = res.data;
        this.loading = false;
      });
    }
  },
  methods: {
    submit() {
      this.error = null;

      if (!this.template || !this.form.gender || !this.form.subject) {
        return (this.error = "Please complete all required fields.");
      }

      this.formLoading = true;

      const mode = this.form._id ? "patch" : "post";
      const URL = this.form._id
        ? `/api/assessments/${this.form._id}`
        : "/api/assessments";

      // Editing and creating
      this.axios[mode](URL, this.form)
        .then(res => {
          const message =
            mode === "patch"
              ? "Assessment successfully edited."
              : "New assessment successfully added.";

          this.$root.$emit("popup", message);
          this.$router.push("/dashboard/assessments");
        })
        .catch(res => {
          this.error =
            "Interal server error. You may have forgotten to fill out a required field.";
        })
        .finally(() => (this.formLoading = false));
    }
  }
};
</script>

